import React from "react";

export function Section({ id, className = "", children, ...rest }) {
  return (
    <section id={id} className={`py-20 lg:py-28 ${className}`} {...rest}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">{children}</div>
    </section>
  );
}

export function SectionLabel({ children }) {
  return (
    <div className="inline-flex items-center gap-2 mb-4">
      <span className="h-px w-6 bg-[#A7B584]" />
      <span className="uppercase tracking-[0.18em] text-xs font-semibold text-[#5A5B5C]">
        {children}
      </span>
    </div>
  );
}
